import moment from 'moment/moment'
const dateFormat = 'YYYY-MM-DD'

export default class CampaignEmployeesModel {
  constructor (data) {
    this.key = data.id
    this.completed = data.completed ? 'yes' : 'no'
    this.completedOn = data.completedOn ? moment.parseZone(data.completedOn).format(dateFormat) : ''
    this.firstName = data.employee.firstName
    this.lastName = data.employee.lastName
    this.email = data.employee.email
    this.employeeId = data.employee.id
    this.manager = `${data.manager.firstName} ${data.manager.lastName}`
    this.code = data.code
  }
}



// WEBPACK FOOTER //
// ./src/api/extra-campaigns/CampaignEmployeesModel.js